module.exports = __webpack_public_path__ + "line-awesome.131b7f1e91a652791f08.svg";


//////////////////
// WEBPACK FOOTER
// /builds/faixa-azul/faixa-azul-fad-web/src/assets/vendors/line-awesome/fonts/line-awesome.svg?v=1.1.
// module id = ../../../../../src/assets/vendors/line-awesome/fonts/line-awesome.svg?v=1.1.
// module chunks = styles